export default __webpack_public_path__ + "locales/fr/ConvertPasswordDialog.json?hash=18e2bc0c0ccf5fe5549c682dc040b9d0";